module.exports = __webpack_public_path__ + "static/media/1.de1ba8b6.jpg";